import { mapGetters } from 'vuex'
import { Query } from '@/modules/plugins/query'
// import isEmpty from 'lodash.isempty'
// import { EventBus } from '@/modules/plugins/modules/event'

export default {
    data() {
        return {
            asap: true,
            value: null,
            calculate: false,
        }
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            allowance: 'allowance',
            deliveryPeriod: 'deliveryPeriod',
            activeRestaurant: 'active/restaurant',
            orderAddress: 'order/address',
            orderTime: 'order/time',
            orderAsap: 'order/asap',
            smDevice: 'smDevice',
            needToSetQuery: 'site/needToSetQuery',
            deliveryFirstAvailable: 'deliveryFirstAvailable',
        }),
        noTimeLimit() {
            // Is the selected allowance has any time limit?
            let timeIntervals
            if (this.allowance && this.allowance.days && this.value)
                timeIntervals = this.allowance.days.find(
                    (aDay) => aDay.day === this.$moment(this.value).isoWeekday()
                )?.time_intervals
            if (!timeIntervals) return true
            if (timeIntervals.length > 1) return false
            return (
                this.isBetween(timeIntervals[0].open, '00:00', '00:15') &&
                this.isBetween(timeIntervals[0].close, '23:45', '23:59')
            )
        },
        closed() {
            return this.activeRestaurant?.closed
        },
        acceptPreorder() {
            return this.activeRestaurant?.is_preorder
        },
        asapEnabled() {
            return this.deliveryPeriod?.immediate_available
        },
        dontApplyTimeRules() {
            return (
                this.allowance?.time_settings_dont_apply_to_non_company_addresses &&
                !this.orderAddress?.is_company_address
            )
        },
        days() {
            return Object.keys(this.deliveryPeriod?.days || {}).map((day) => {
                let result = this.$moment(day)
                result.disabled = !this.deliveryPeriod?.days[day].length
                return result
            })
        },
        times() {
            return this.deliveryPeriod?.days?.[
                this.value ? this.$moment(this.value).format('YYYY-MM-DD') : undefined
            ]?.reduce((p, c) => {
                if (this.$moment().isBefore(c.from)) p.push(c)
                return p
            }, [])
        },
    },

    methods: {
        isBetween(value, from, to) {
            return this.$moment(value, 'HH:mm').isBetween(
                this.$moment(from, 'HH:mm'),
                this.$moment(to, 'HH:mm'),
                'minute',
                '[]'
            )
        },
        open(calculate = false) {
            if (!this.asap && this.orderTime) this.setTime(this.orderTime)
            if ((this.asap && !this.asapEnabled) || (!this.asap && !this.isValidDate(this.value))) {
                this.asap = false
                this.setTime(this.$moment(this.deliveryFirstAvailable).valueOf())
                this.doCalculate()
                this.setDeliveryTime()
            }
            this.$nextTick(() => {
                this.$refs.ModalDeliveryTime.openModal()
            })
            this.calculate = calculate
        },
        close() {
            this.doCalculate()
            this.$refs.ModalDeliveryTime.closeModal()
            this.calculate = false
            this.setTime(this.orderTime)
        },
        cancel(close) {
            this.asap = this.orderAsap
            this.setTime(this.orderTime)
            this.calculate = false
            if (close) this.$refs.ModalDeliveryTime.closeModal()
        },
        setValue(asap) {
            if (asap) this.setTime()
            else this.setLater()
        },
        setTime(time) {
            this.value = time
        },
        async doCalculate() {
            if (this.calculate) await this.$cart.calculate()
            return Promise.resolve()
        },
        setLater() {
            const firstOffered = this.firstOfferedTime()
            if (firstOffered) this.setTime(firstOffered)
        },
        // the first offered window that still starts in the future (what "schedule for later" preselects), or undefined
        firstOfferedTime() {
            const now = this.$moment()
            for (const day of this.days) {
                if (day.disabled) continue
                const range = (
                    this.deliveryPeriod?.days?.[this.$moment(day).format('YYYY-MM-DD')] || []
                ).find((r) => now.isBefore(r?.from))
                if (range) return this.$moment(range.from).valueOf()
            }
            return undefined
        },
        async confirm(closeModal = true) {
            await Promise.all([this.doCalculate(), this.setDeliveryTime()])
            if (closeModal) this.close()
        },
        async setDeliveryTime() {
            await this.$store.dispatch('order/setAsap', this.asap)
            await this.$store.dispatch(this.asap ? 'order/resetTime' : 'order/setTime', this.value)
            if (this.needToSetQuery)
                this.setQuery(Query.getDeliveryTimeQuery(this.asap ? undefined : this.orderTime))
            this.$user.getExpenseRules()
            return true
        },
        initDeliveryTime(/* query */) {
            // const deliveryTime = query.delivery ? Number(query.delivery) : undefined
            let resultTime
            // if (
            //     deliveryTime &&
            //     this.isFutureDate(deliveryTime) &&
            //     deliveryTime !== this.orderTime?.valueOf()
            // ) {
            //     resultTime = deliveryTime
            // }
            if (!resultTime && this.orderTime && this.isFutureDate(this.orderTime)) {
                resultTime = this.orderTime
            }
            this.setTime(resultTime ? resultTime : undefined)
            this.asap = !resultTime
            this.setDeliveryTime()
        },
        isFutureDate(time) {
            return this.$moment(time).isAfter(this.$moment(), 'minute')
        },
        isValidDate(date) {
            return !!Object.entries(this.deliveryPeriod?.days).find(([day, ranges]) => {
                if (this.$moment(day).isSame(date, 'day')) {
                    return !!ranges.find((range) => this.$moment(range.from).isSame(date, 'minute'))
                }
                return false
            })
        },
    },
}
